// extracted by mini-css-extract-plugin
export default {"homePage":"HomePage_homePage__Rbwav","visuallyHidden":"HomePage_visuallyHidden__11KFa"};